import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formConfigs } from "./formConfigs";
import "./AddNewForm.css"; 
import MultiSelect from "../designSystem/MultiSelect";
import SingleSelect from "../designSystem/SingleSelect";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import { Check } from "lucide-react";
import Textarea from "../designSystem/TextArea";
import TextField from "../designSystem/TextField";
import { validateFields } from "../../utils/Validations";
import { t } from "../../locales/translate";

function AddNewForm({ itemName, onClose, onSave, editData }) {
  const dispatch = useDispatch();
  const config = formConfigs[itemName];
  const [formValues, setFormValues] = useState(config.initialValues);
  
  const [formErrors, setFormErrors] = useState({});
const permissions = JSON.parse(localStorage.getItem('permissionsList')) || [];
const canAdd = !config.requiredPermission || permissions.includes(config.requiredPermission);
  const dropdownOptions = {};
  config.fields.forEach((field) => {
    if ((field.type === "select" || field.type === "multiselect") && field.optionsSelector) {
      dropdownOptions[field.name] = useSelector(field.optionsSelector);
    }
  });

  useEffect(() => {
    if (config.fetchDependencies) {
      config.fetchDependencies(dispatch);
    }
  }, [dispatch, config]);

  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);

  useEffect(() => {
    if (editData) {
      const newData = { ...editData };
      if (itemName === "role" && Array.isArray(editData.roleGroup)) {
        newData.roleGroup = editData.roleGroup.map(group => group.value ?? group.id);
      }
      setFormValues(newData);
    }
  }, [editData, itemName]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = validateFields(formValues, formConfigs[itemName].validateKey);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (editData) {
        dispatch(config.updateAction(formValues));
      } else {
        dispatch(config.addAction(formValues));
      }
      if (onSave) onSave(formValues);
      onClose();
    }
  };

  const handleClose = () => {
  setFormErrors({});
  setFormValues(config.initialValues);
      onClose();
    };

  return (
    <form className="addnewform-container" onSubmit={handleSubmit}>
      {config.fields.map((field) => (
        <div key={field.name} className="addnewform-group">
          {field.type !== "checkbox" && <label>{field.label}</label>}

          {field.type === "text" && (
            <TextField
              type="text"
              name={field.name}
              value={formValues[field.name] || ""}
              onChange={handleChange}
              error={formErrors[field.name]}
            />
          )}

          {field.type === "textarea" && (
            <Textarea
              name={field.name}
              value={formValues[field.name] || ""}
              onChange={handleChange}
              placeholder={field.label}
              width="365px"
              error={formErrors[field.name]}
            />
          )}

         {field.type === "select" && field.name === "city" ? (
  <SingleSelect
    isSearchable
    options={
      dropdownOptions.city?.result?.[0]?.cities?.map(city => ({
        value: city.id,
        label: city.name,
      })) || []
    }
    value={formValues.city || ""}
    onChange={(selectedOption) => {
      setFormValues(prev => ({
        ...prev,
        city: selectedOption?.value || "",
      }));
    }}
    placeholder={`${field.label}`}
    error={formErrors.city}
  />
) : field.type === "select" ? (
  <SingleSelect
    isSearchable
    options={
      dropdownOptions[field.name]?.result?.map(opt => ({
        value: opt.id,
        label: opt.name,
      })) || []
    }
    value={formValues[field.name] || ""}
    onChange={(selectedOption) => {
      setFormValues(prev => ({
        ...prev,
        [field.name]: selectedOption?.value || "",
      }));
    }}
    placeholder={`${field.label}`}
    error={formErrors[field.name]}
  />
) : null}


          {field.type === "multiselect" && (
            <MultiSelect
            isSearchable
              options={dropdownOptions[field.name] || []}
              value={formValues[field.name] || []}
              onChange={(selectedValues) => {
                setFormValues(prev => ({
                  ...prev,
                  [field.name]: selectedValues || [],
                }));
              }}
              placeholder={`${field.label}`}
              error={formErrors[field.name]}
            />
          )}

          {field.type === "checkbox" && (
            <>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name={field.name}
                  checked={!!formValues[field.name]}
                  onChange={handleChange}
                />
                <span>{field.label}</span>
              </label>
              {formErrors[field.name] && (
                <div className="error-text">{formErrors[field.name]}</div>
              )}
            </>
          )}
        </div>
      ))}

      <div className="addnewform-footer">
        <CancelButton type="button" text={t("cancel")} width={document.body.dir === "rtl" ? "119px" : ""}  onClick={(e) => {
        e.preventDefault(); 
        handleClose();
        }} 
        />
        <PrimaryButton
          type="submit"
          text={t("save")}
          icon={Check}
          isLoading={false}
          onClick={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
          width={document.body.dir === "rtl" ? "123px" : ""}
        />
      </div>
    </form>
  );
}

export default AddNewForm;
